/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2022. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
/*global module require window*/
"use strict";

var analytics = require("../../lib/shared/analytics");
var capabilitiesModel = require("../common/model/capability");
var applySecretValidator = capabilitiesModel.applySecretValidator;
Object.assign = Object.assign || require("object-assign");
var CapabilityController = function CapabilityController(args) {
  var capability = this.capability = args.capability;
  capability = this.capability = applySecretValidator(capability);
  this.metadata = capability.metadata;
  this.schema = capability.schema;
  this.parameters = capability.parameters;
  this.onValidatorEvent = args.onValidatorEvent; // function(type, data)
  this.onParameterChange = args.onParameterChange;
  this.validators = [];
  this.wizardStep = args.wizardStep;
  // Note this.authorizationURI on this CapabilityController is set/deleted in validator/2.jsx
};
CapabilityController.prototype = {
  addValidator: function addValidator(validator) {
    this.validators.push(validator);
  },
  populate: function populate(changeSummary) {
    this.validators.forEach(function (validator) {
      validator.populate(changeSummary);
    });
  },
  validate: function validate() {
    this.validators.forEach(function (validator) {
      validator.validate();
    });
  },
  restart: function restart() {
    // This function is called when a validator has returned an unexpected error
    // and the user then hits the 'Retry' button. Clear the formError
    // and restart the validation cycle.
    delete this.formError;
    this.validators.forEach(function (validator) {
      validator.authenticate(true);
    });
  },
  setDotProperty: function setDotProperty(name, obj, value) {
    var index = name.indexOf(".");
    if (index === -1) {
      obj[name] = value;
      return;
    }
    var part = name.substring(0, index);
    return this.setDotProperty(name.substring(index + 1, name.length), obj[part], value);
  },
  handleAuthenticate: function handleAuthenticate() {
    analytics.track("auth.oauth.start", {
      label: this.capability.capabilityId
    });
    this.popup = window.open(this.authorizationURI);
  },
  handleFieldChange: function handleFieldChange(evt) {
    var name = evt.target.name || evt.target.getAttribute("name");
    if (name && name.includes('_') && evt.target.getAttribute && evt.target.getAttribute('data-paramdef-type') === 'boolean') {
      // note, to prevent boolean checkboxes from being flagged by a11y
      // as checkbox group spread across multiple forms,
      // boolean checkbox name was prefixed by the capability/form name
      var prefix = this.capability.label + '_';
      if (name.startsWith(prefix)) {
        name = name.substring(prefix.length);
      }
    }
    var newValue = getElementValue(evt.target);
    if (typeof name === "string" && /[\w+]\.[\w+]/gi.test(name)) {
      this.setDotProperty(name, this.parameters, newValue);
    } else {
      this.parameters[name] = newValue;
    }
    var changeSummary = Object.create(null);
    changeSummary[name] = {
      source: "user"
    };
    // Callback into model to update refs
    this.updateRefs(changeSummary);
  },
  updateRefs: function updateRefs(changeSummary) {
    var callback = this.onParameterChange;
    if (typeof callback === "function") {
      callback(this.capability, changeSummary, {
        wizardStep: this.wizardStep
      });
    }
  }
};
function getElementValue(el) {
  if (el.type && el.type === "checkbox") {
    return el.checked; // boolean
  }
  if (typeof el.value === 'string') {
    return el.value;
  }
  if (el.getAttribute) {
    return el.getAttribute("value");
  }
  return el.value;
}
module.exports = CapabilityController;